import { createStoreFromUrl, http, MessageBool } from "../base";

class ProductOrderService {
    apiPath = "/api/productorder";

    getDxData() {
        return createStoreFromUrl(`${this.apiPath}/dx`, 'id');
    }
    
    getDeletedDxData() {
        return createStoreFromUrl(`${this.apiPath}/deleteddx`, 'id');
    }

    setNote(model: { id: number, note: string}) {
        return http.putData<MessageBool>(`${this.apiPath}/note`, model);
    }

    restore(id: number) {
        return http.putData<MessageBool>(`${this.apiPath}/restore/${id}`, '');
    }

    delete(id: number) {
        return http.deleteData<MessageBool>(`${this.apiPath}/${id}`);
    }
}

export const productOrderService = new ProductOrderService();
export const productOrderStore = productOrderService.getDxData();
export const productOrderDeletedStore = productOrderService.getDeletedDxData();